import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule, UrlModule} from '@spartacus/core';
import {GenericConfiguratorErrorModule} from '../generic-configurator-error/generic-configurator-error.module';
import {NgDesignSystemModule} from 'ng-design-system';
import {ContactCtaModule} from '../../../../contact-cta/contact-cta.module';
import {
  AddToExistingContractErrorComponent
} from './add-to-existing-contract-error/add-to-existing-contract-error.component';
import {AddCompanyDetailsErrorComponent} from './add-company-details-error/add-company-details-error.component';
import {NewContractErrorComponent} from './new-contract-error/new-contract-error.component';
import {OpenPdpLinkComponent} from './open-pdp-link/open-pdp-link.component';
import {CancelCtaButtonComponent} from './cancel-cta-button/cancel-cta-button.component';
import {GenericLinkModule} from '@spartacus/storefront';
import {CheckoutUnavailableComponent} from './checkout-unavailable/checkout-unavailable.component';
import {ConfigureRestructureErrorComponent} from './configure-restructure-error/configure-restructure-error.component';

@NgModule({
  declarations: [
    AddToExistingContractErrorComponent,
    AddCompanyDetailsErrorComponent,
    NewContractErrorComponent,
    OpenPdpLinkComponent,
    CancelCtaButtonComponent,
    CheckoutUnavailableComponent,
    ConfigureRestructureErrorComponent
  ],
  exports: [
    AddToExistingContractErrorComponent,
    AddCompanyDetailsErrorComponent,
    NewContractErrorComponent,
    CheckoutUnavailableComponent,
    ConfigureRestructureErrorComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    GenericConfiguratorErrorModule,
    NgDesignSystemModule,
    ContactCtaModule,
    GenericLinkModule,
    UrlModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class NetNewModule {
}
